import axios from 'axios';

import {
  getJsonData,
  setJsonUrl,
  getQueryObj
} from '../utility/functions';

export default function setLoadMore() {

  /* Element */
  const worksList = document.getElementById('js-works');
  const btn = document.getElementById('js-loadMore');
  const fillterBtn = document.querySelectorAll('.js-fillter');
  let category = 'works'; // カテゴリ名
  let jsonUrl = `/wp-json/wp/v2/${category}`
  let page = 1; //初期ページ (初期表示はPHPで出力するため、追加記事があるかの判定)
  let per_page = 9; //取得件数 本番では9件
  let meta_key = 'all';
  let meta_value = 'all';
  let datas = [];
  let flag = false;
  let parms, totalPage, viewItem;

  /* RestAPIで記事の取得 */
  const setData = () => {
    parms = {
      'page': page,
      'per_page': per_page,
      'meta_key': meta_key,
      'meta_value': meta_value,
    }
    if (meta_key === 'all') {
      delete parms['meta_key'];
    }
    if (meta_value === 'all') {
      delete parms['meta_value'];
    }
    let url = setJsonUrl(jsonUrl, parms);
    axios.get(url).then(function (response) {
      datas = response.data;
      // トータルページ数判定
      viewItem = parseInt(response.headers['x-wp-total']);
      totalPage = parseInt(response.headers['x-wp-totalpages']);
      if (totalPage > page) {
        btn.classList.add('is-view');
      } else {
        btn.classList.remove('is-view');
      }
      // 表示するものがない時
      if (viewItem == 0) {
        listNone();
      }
      // 初回ロード時はパースしない
      if (flag == true) {
        setParse();
      }
    }).catch(function (error) {
      console.log('ERROR!! occurred in Backend.')
    });
  }

  /* worksリストに要素を追加する */
  function setParse() {
    datas.forEach(elm => {
      let ttl = elm['title']['rendered'],
      worksUrl = elm['link'],
      mainCat = elm['acf']['main_category']['label'],
      subCat = elm['acf']['sub_category']['label'],
      thumb = elm['acf']['thumb_img'],
      subTtl = elm['acf']['sub_title'];
      // サムネイル画像が存在しない時の処理
      thumb = (thumb == '') ? '/asset/images/common/no_image.jpg' : thumb['sizes']['post_works_thumb'];
      let row = `
        <a href="${worksUrl}">
          <div class="c-works__img">
            <img src="${thumb}" alt="${ttl}">
            <div class="c-works__mask"></div>
            <p class="c-works__view">VIEW MORE</p>
          </div>
          <dl class="c-works__category">
            <dt>${mainCat}</dt>
            <dd>${subCat}</dd>
          </dl>
          <dl class="c-works__title">
            <dt>${ttl}</dt>
            <dd>${subTtl}</dd>
          </dl>
        </a>
      `;
      let li = document.createElement('li'); // Works list の最後尾に追加
      li.innerHTML = row;
      worksList.appendChild(li);
    });
  }

  /* 何も取得できなかった時 */
  function listNone() {
    let li = document.createElement('li'); // Works list の最後尾に追加
    li.innerHTML = '<small class="c-works__note">該当する作品がありません</small>';
    worksList.appendChild(li);
  }

  /* load moreボタンクリック */
  btn.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    page++;
    flag = true;
    setData();
  });

  /* filtter */
  Array.from(fillterBtn).forEach(elm => {
    elm.addEventListener('click', (e) => {
      meta_key = e.target.getAttribute('data-metakey');
      meta_value = e.target.getAttribute('data-metavalue');
      page = 1;
      flag = true;
      btn.classList.remove('is-view');
      elmDel().then(res => {
        setData();
      });
    });
  });
  const elmDel = () => {
    return new Promise((resolve, reject) => {
      worksList.classList.add('is-disapper');
      setTimeout(() => {
        worksList.textContent = null;
        worksList.classList.remove('is-disapper');
        resolve(true);
      }, 800);
    });
  }
  setData();

}